<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>用卡记录</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="content">
      <div class="navbtn">
        <el-card class="button-content">
        <el-button type="primary" size="small" icon="el-icon-refresh" circle @click="refresh" :loading="state"></el-button>
        </el-card>
      </div>

      <el-form :inline="true" :model="queryInfo" class="demo-form-inline" ref="searchFormRef" size="small" style="margin:20px 0">
        <el-form-item label="软件 " prop="softName" >
          <el-select v-model="queryInfo.softName" placeholder="全部软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="动作 " prop="action" >
          <el-select v-model="queryInfo.action" placeholder="所有" clearable @change="changeInput()">
            <el-option label="注册" value="注册"></el-option>
            <el-option label="充值" value="充值"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="账号" prop="cardPassword">
          <el-input v-model="queryInfo.username"  clearable placeholder="支持模糊查询" :style="inputWidth?{width:'100%'}:{width:'300px'}"></el-input>
        </el-form-item>
        <el-form-item label="卡密" prop="cardPassword">
          <el-input v-model="queryInfo.cardPassword"  clearable placeholder="支持模糊查询" :style="inputWidth?{width:'100%'}:{width:'300px'}"></el-input>
        </el-form-item>
        <el-button type="primary" size="small" @click="query" :loading="state" icon="el-icon-search">查 询</el-button>
        <el-button size="small" @click="reSet" :loading="state" icon="el-icon-refresh-left">重 置</el-button>
      </el-form>

      <el-table :data="tableUserLog" border style="width: 100%" stripe v-loading="loading">
        <el-table-column prop="username" label="账号" width="180"></el-table-column>
        <el-table-column prop="softName" label="所属软件" width="180"></el-table-column>
        <el-table-column prop="action" label="动作" width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.action === '登录'" style="color: #0050b3">登录</span>
            <span v-if="scope.row.action === '充值'" style="color: #237804">充值</span>
            <span v-if="scope.row.action === '注册'" style="color: #ad6800">注册</span>
          </template>
        </el-table-column>
        <el-table-column prop="cardPassword" label="使用卡密" width="380"></el-table-column>
        <el-table-column prop="cardName" label="卡类" width="200"></el-table-column>
        <el-table-column prop="createDate" label="卡类时间" width="170"></el-table-column>
        <el-table-column prop="remarks" label="备注" width="170"></el-table-column>
        <el-table-column prop="createDate" label="使用时间" width="170"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data(){
    return{
      state:false,
      loading:true,
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email: this.$store.state.account,
        username:""
      },
      inputWidth:false,
      total:0,

      allSoftName:[],
      tableUserLog:[]
    }
  },
  created(){
    this.$nextTick(()=>{
      if (document.body.clientWidth < 700){
        this.diaLogWidth = '100%'
        this.inputWidth = true
        this.editDialogWidth = '100%'
      }
    })
    this.getCardTypeSoftName()
    if(window.sessionStorage.getItem('username')){
      this.getUserLog(window.sessionStorage.getItem('username'))
      window.sessionStorage.removeItem('username')
    }else{
      this.getUserLog()
    }
  },
  methods:{
    async getUserLog(index){
      this.state = true
      if(index){
        this.queryInfo.username = index
      }
      const result = await this.$http.get("userLog",{
        params:this.queryInfo
      });
      this.state = false
      console.log('result',result);
      console.log('result.data.data.total',result.data.data.total);
      if(!result.data.data.total){
        this.total = 0
        this.tableUserLog = []
        this.loading = false
        return
      }
      //this.tableUserList = result.data.data.data
      this.tableUserLog = result.data.data.data.map(element =>{
        if(element.createDate){
          element.createDate = this.timestampToTime(parseInt(element.createDate))
        }
        if(element.expireDate){
          element.expireDate = this.timestampToTime(parseInt(element.expireDate))
        }
        if(element.latelyDate){
          element.latelyDate = this.timestampToTime(parseInt(element.latelyDate))
        }
        return element
      })
      this.total = result.data.data.total
      //console.log('total',this.total);
      this.loading = false
    },
    async getCardTypeSoftName(){
      this.state = true
      const result = await this.$http.post("cardGetSoft", {email:this.$store.state.account});
      this.state = false
      //console.log(result);
      this.allSoftName = result.data.data.result.map(element => {
        return element.softName
      })
    },
    query(){
      this.queryInfo.pagenum = 1
      this.getUserLog()
    },
    reSet(){
      console.log('重置');
      this.queryInfo.softName = ""
      this.queryInfo.action = ""
      this.queryInfo.cardPassword = ""
      this.queryInfo.username = ""
      this.$refs.searchFormRef.resetFields()
      this.getUserLog()
    },
    refresh(){
      this.getUserLog()
    },

    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val
      this.getUserLog()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.queryInfo.pagenum = val
      this.getUserLog()
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp);
      var year = date.getFullYear();
      var month = (date.getMonth() + 1 < 10 ? (date.getMonth() + 1) : date.getMonth() + 1);
      var day = date.getDate();
      var hours = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      if (month < 10) { month = '0' + month }
      if (day < 10) { day = '0' + day }
      if (hours < 10) { hours = '0' + hours }
      if (minute < 10) { minute = '0' + minute }
      if (second < 10) { second = '0' + second }
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minute + ':' + second;
    },
    changeInput(e){
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  margin: 5px;
  .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
  .el-dropdown{
    margin-left: 10px;
    color: #409EFF;
  }
  .el-table{
    .el-button{
      margin-left: 10px
    }
  }
}
.custom{
  display: flex;
  justify-content: flex-start;
  .el-switch{
    margin-left: 10px;
  }
}
</style>